import BaseServiceRetryWrapper from './baseRetry';
import { COMPANY_MEASUREMENT_DATES } from '../common/endpoints';

class CompanyMeasurementDatesService extends BaseServiceRetryWrapper {
  byMeasurementDate = measurementDateId => this.get(COMPANY_MEASUREMENT_DATES.byMeasurementDate(measurementDateId));
}

export default CompanyMeasurementDatesService;
